import React from 'react';
import {
  Stack,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const FoodTypesTitle = ({ onChange, value }) => {
  const { t } = useTranslation('translation');
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={2}
    >
      <Box>
        <Typography variant="h6" mb={1} color="black">
          {t('donations.food-types')}
        </Typography>
        <Typography color="text.secondary" variant="body2">
          {t(
            'donations.choose-the-food-types-you-want-to-donate-to-set-the-amount'
          )}
        </Typography>
      </Box>
      {onChange && (
        <Stack
          sx={{
            flexShrink: 0,
            backgroundColor: 'grey.200',
            borderRadius: 1,
            py: 1,
            pr: 2,
            pl: 1,
          }}
        >
          <FormControlLabel
            labelPlacement="start"
            label={t('donations.allow-partial-rescue')}
            control={
              <Checkbox
                onChange={(e) => onChange(e.target.checked)}
                checked={value}
              />
            }
          />
        </Stack>
      )}
    </Stack>
  );
};

export default FoodTypesTitle;
